import React, { createContext, useContext } from 'react';

type EditorModeContextType = {
  isInEditor: boolean;
};

const EditorModeContext = createContext<EditorModeContextType>({
  isInEditor: true,
});

export const useEditorMode = () => useContext(EditorModeContext);

type Props = {
  isInEditor: boolean;
  children: React.ReactNode;
};

export const EditorModeProvider: React.FC<Props> = ({ isInEditor, children }) => (
  <EditorModeContext.Provider value={{ isInEditor }}>{children}</EditorModeContext.Provider>
);
